import { show, hide } from "../helpers";
import { _addEventListener, isEventListenerRegistered } from "../eventHelper";
import FocusTrapHelper from "./FocusTrapHelper";

export default class Modal {
    constructor(modalName) {
        this.modalName = modalName;
        this.isOpen = false;
        this.setModalElement();
        if (this.modalElement) {
            this.isDialog = this.modalElement.tagName === "DIALOG";
            this.isOpen = false;
            this.position = null;
            this.delay = 0;
            this.onClosing = null;
            this.onClosed = null;
            this.onOpening = null;
            this.onOpened = null;
            this.init();
            this.addClickBackdropListener();
        }
        LUC.Modals[modalName] = this;
    }

    getModalElement() {
        return this.modalElement;
    }

    getModalName() {
        return this.modalName;
    }

    setModalElement() {
        this.modalElement = document?.querySelector('[data-modal="' + this.modalName + '"]');
    }

    setPosition(x, y) {
        const modalWidth = this.getModalElement().offsetWidth > 0 ? this.getModalElement().offsetWidth : 351;
        x = Math.max(x - modalWidth, 0);
        const viewportWidth = window.innerWidth;
        let top = `top: ${y}px`;
        let left = `left: ${x}px`;
        if (x + modalWidth > viewportWidth) {
            left = `left: ${viewportWidth - modalWidth - 10}px`;
        }

        this.getModalElement().setAttribute("style", left + ";" + top);
    }

    show() {
        if (!this.isOpen) {
            if (this.onOpening && typeof this.onOpening === "function") {
                this.onOpening(this);
            }
            if (this.isDialog) {
                this.getModalElement().showModal();
            } else {
                new FocusTrapHelper(this.getModalElement());
                show(this.getModalElement());
            }
            this.isOpen = true;
            this.addEscListener();
            if (this.onOpened && typeof this.onOpened === "function") {
                this.onOpened(this);
            }
        }
    }

    close(event) {
        let modalName = this.modalName;
        if (event) {
            event.preventDefault();
            // Condition `this.modalName === modalName` checks if multiple modals are open and closes only the active one.
            // Dialog has native functionality to close only the active modal by default. However, we need to mark the object as isOpen and set a delay along with other options.
            modalName = event.target.closest("[data-modal]").getAttribute("data-modal");
        }
        if (this.isOpen && this.modalName === modalName) {
            if (this.onClosing && typeof this.onClosing === "function") {
                this.onClosing(this);
            }
            setTimeout(() => {
                if (this.isDialog) {
                    this.getModalElement().close();
                } else {
                    hide(this.getModalElement());
                }
            }, this.delay);
            this.isOpen = false;
            if (this.onClosed && typeof this.onClosed === "function") {
                this.onClosed(this);
            }
        }
    }

    init() {
        const closeButtons = this.modalElement.querySelectorAll('[data-modal-close="' + this.modalName + '"');
        if (closeButtons.length > 0) {
            closeButtons.forEach((closeButton) => {
                _addEventListener(closeButton, "click", (event) => this.close(event));
            });
        }
    }

    closeEscInput(event) {
        if (event.key === "Escape") {
            this.close(event);
        }
    }

    addEscListener() {
        if (!isEventListenerRegistered(this.getModalElement(), "keydown")) {
            _addEventListener(this.getModalElement(), "keydown", this.closeEscInput.bind(this));
        }
    }

    addClickBackdropListener() {
        _addEventListener(this.getModalElement(), "click", (event) => {
            if (event.target === this.getModalElement()) {
                this.close();
            }
        });
    }

    static getModalByName(modalName) {
        if (typeof LUC.Modals[modalName] === "undefined") {
            new this(modalName);
        }

        return LUC.Modals[modalName];
    }
}
